import DashboardHeader from '../shared/components/DashboardHeader';
import SideMenu from '../shared/components/SideMenu';
import Footer from '../shared/components/Footer';
import React, { useState, useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import HttpCall from '../api/Http';
import User from '../shared/Utils/User';
import { useSearchParams } from "react-router-dom";

// export default function Billing() {

const user = JSON.parse(localStorage.getItem('user'))
const stripePromise = loadStripe('pk_test_51LnRHvGzrU0sb1NUDSaCiFTbeCSdbZVY3tHByedtfBTfyh3hsofwISiKPJxNplc0S9pG4ovgVzyEB4t7zC1RjjFz000PceCfRn');




export default function App() {
  let [message, setMessage] = useState('');
  let [success, setSuccess] = useState(false);
  const [isRun, setIsRun] = useState(false);

  let [sessionId, setSessionId] = useState('');
  let [paymentIntentId, setPaymentIntentId] = useState('');
  const [showCheckout, setShowCheckout] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  let [options = {
    // passing the client secret obtained from the server
    clientSecret: '',
  }, setOptions] = useState(false);

  const user = User.getUser()
  let customerId = "";
  useEffect(() => {
    if (isRun) { return; }
    setPaymentIntentId(searchParams.get("payment_intent"))
    if (paymentIntentId == null) {
      registerCustomer();
    }
    else {
      if (searchParams.get("redirect_status") == "succeeded") {
        setSuccess(true);
        setIsRun(true)
      }
    }
  })

  function closePopup(e) {
    e.preventDefault();
    setSuccess(false);
  }


  const registerCustomer = () => {
    let requestData = new FormData();
    requestData.append('UserId', user[0].Id);
    requestData.append('Email', user[0].Email);
    requestData.append('UserName', user[0].User_Name);

    let url = `/api/Payment/register-customer`;
    HttpCall.postRequest(url, requestData).then(response => {
      customerId = response.data;
    });
  }

  const paymentInit = (e, priceId) => {
    e.preventDefault();

    let requestData = new FormData();
    requestData.append('customerId', customerId);
    requestData.append('priceId', priceId);

    let url = `/api/Payment/create-subscription`;
    HttpCall.postRequest(url, requestData).then(response => {
      let option = {
        // passing the client secret obtained from the server
        clientSecret: response.data.clientSecret,
      }
      setOptions(option)
      setShowCheckout(true);
    });
  }

  return (

    <div>
      {showCheckout && <Elements stripe={stripePromise} options={options}>
        <CheckoutForm />
      </Elements>
      }
      {!showCheckout && <div>
        <div>
          <form className="forms-sample">
            <h4>
              Free + Basic Plan
            </h4>
            <h4>
              $ 500
            </h4>
            <button className="btn btn-primary me-2 savebtn" onClick={e => { paymentInit(e, 'price_1M17QFGzrU0sb1NUMB4mdgqk') }}>Start</button>
          </form>
        </div>
        <div>
          <form className="forms-sample">
            <h4>
              Standard Plan
            </h4>
            <h4>
              $ 1500
            </h4>
            <button className="btn btn-primary me-2 savebtn" onClick={e => { paymentInit(e, 'price_1M17SiGzrU0sb1NU8Mrn1RxK') }}>Start</button>
          </form>
        </div>
      </div>}

      {success && <div id="SuccessfullyModal" className="modal" style={{ display: 'block' }}>
        <div className="modal-content">
          <span className="close3 closebtn">&times;</span>
          <i className="mdi mdi-checkbox-marked-circle-outline"></i>
          <h1>We received your purchase request</h1>
          <button type="button" className="btn btn-primary btn-rounded btn-md" onClick={closePopup}>OK</button>
        </div>
      </div>}

    </div>



  );
}

// const CheckoutForm = () => {
//   return (
//     <form>
//       <PaymentElement />
//       <button>Submit</button>
//     </form>
//   );
// };


const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const result = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: "http://localhost:3000/billing/123/complete",
      },
    });


    if (result.error) {
      // Show error to your customer (for example, payment details incomplete)
      alert(result.error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <button className='btn btn-primary me-2 savebtn' disabled={!stripe}>Submit</button>
    </form>
  )
};

//   return (
//     <>
//       <DashboardHeader />
//       <div className="container-fluid page-body-wrapper">
//         <SideMenu />
//         <script src="https://js.stripe.com/v3/"></script>
//         <div class="main-panel">
//           <div class="content-wrapper">
//             <div class="row">

//               <div class="col-md-12 grid-margin stretch-card">
//                 <div class="card">
//                   <div class="card-body">
//                     <h4 class="card-title">Payment &#62; Card Details</h4>
//                     <p class="card-description">
//                       You can always feel confident that your credit card information is safe and secure at GetBound.
//                     </p>
//                     <form class="forms-sample">

//                       <h6>Payment Method</h6>
//                       <div class="row">
//                         <div class="col-md-2">
//                           <div class="form-group">
//                             <div class="form-check">
//                               <label class="form-check-label">
//                                 <input type="radio" class="form-check-input" name="optionsRadios" id="optionsRadios1" value="" />
//                                 Credit Card
//                                 <i class="input-helper"></i></label>
//                             </div>
//                           </div>
//                         </div>

//                         <div class="col-md-2">
//                           <div class="form-group">
//                             <div class="form-check">
//                               <label class="form-check-label">
//                                 <input type="radio" class="form-check-input" name="optionsRadios" id="optionsRadios1" value="" />
//                                 PayPal
//                                 <i class="input-helper"></i></label>
//                             </div>
//                           </div>
//                         </div>
//                       </div>

//                       <div class="row">

//                         <div class="col-md-6">
//                           <div class="form-group">
//                             <label>Card Number</label>
//                             <input type="name" class="form-control form-control-lg" placeholder="Enter Card Number" />
//                           </div>
//                         </div>

//                         <div class="col-md-6">
//                           <div class="form-group">
//                             <label>Card Verification Value</label>
//                             <input type="name" class="form-control form-control-lg" placeholder="Enter Card Verification Value" />
//                           </div>
//                         </div>

//                       </div>

//                       <div class="row">

//                         <div class="col-md-6">
//                           <div class="form-group">
//                             <label>Expires (Month)</label>
//                             <input type="name" class="form-control form-control-lg" placeholder="Enter Expires (Month)" />
//                           </div>
//                         </div>

//                         <div class="col-md-6">
//                           <div class="form-group">
//                             <label>Expires (Year)</label>
//                             <input type="name" class="form-control form-control-lg" placeholder="Enter Expires (Year)" />
//                           </div>
//                         </div>

//                       </div>


//                       <h6>Credit card holder's address</h6>
//                       <br />
//                       <div class="row">

//                         <div class="col-md-6">
//                           <div class="form-group">
//                             <label>Card Holder Name</label>
//                             <input type="name" class="form-control form-control-lg" placeholder="Enter Card Holder Name" />
//                           </div>
//                         </div>

//                         <div class="col-md-6">
//                           <div class="form-group">
//                             <label>Address</label>
//                             <input type="name" class="form-control form-control-lg" placeholder="Enter Address" />
//                           </div>
//                         </div>

//                       </div>
//                       <div class="row">

//                         <div class="col-md-4">
//                           <div class="form-group">
//                             <label>City</label>
//                             <input type="name" class="form-control form-control-lg" placeholder="Enter City" />
//                           </div>
//                         </div>

//                         <div class="col-md-4">
//                           <div class="form-group">
//                             <label>Zip Code</label>
//                             <input type="name" class="form-control form-control-lg" placeholder="Enter Zip Code" />
//                           </div>
//                         </div>

//                         <div class="col-md-4">
//                           <div class="form-group">
//                             <label>Country</label>
//                             <input type="name" class="form-control form-control-lg" placeholder="Enter Country" />
//                           </div>
//                         </div>

//                       </div>

//                       <div class="col-md-12">
//                         <div class="form-group">
//                           <div class="form-check">
//                             <label class="form-check-label">
//                               <input type="checkbox" class="form-check-input" />
//                               Until further notice, I agree that GetBound will collect all amounts due from the above credit card.
//                               <i class="input-helper"></i></label>
//                           </div>
//                         </div>
//                       </div>


//                       <div class="row">
//                         <div class="col-md-6">
//                           <button type="submit" class="btn btn-primary me-2 savebtn">Save</button>
//                         </div>
//                         <div class="col-md-6">
//                           <button class="btn btn-light me-2 savebtn">Cancel</button>
//                         </div>
//                       </div>

//                     </form>
//                   </div>
//                 </div>
//               </div>






//             </div>
//           </div>


//           <footer class="footer">
//             <div class="d-sm-flex justify-content-center justify-content-sm-between">

//               <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Copyright © 2023 <a href="http://getbound.ai/">Getbound.ai</a> - All rights reserved</span>
//             </div>
//           </footer>

//         </div>


//       </div>
//     </>
//   )
// }
